import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Col, Row } from 'react-bootstrap'

import * as blUrls from 'lib/urls'
import { LightButton } from 'components/buttons'
import Image from 'components/image'
import Link from 'components/link'
import * as BLConstants from 'shared/constants'
import { withContextualizedTracking } from 'lib/analytics'
import * as css from './footer.scss'
import { getNav, mobileNav } from './constants'
import SocialLinks from './SocialLinks'

const Footer = ({ loggedIn }) => (
  <div className="container">
    <Row>
      <Link url={blUrls.indexPath} aria-label="home">
        <Image
          alt="babylist-logo"
          className="mvl visible-xs col-centered"
          height="38"
          width="170"
          src="//res.cloudinary.com/babylist/image/upload/f_auto,q_auto/v1549314083/Babylist_logo_horizontal_white_qltnll.svg"
        />
      </Link>
      <Col className="visible-xs" sm={12}>
        <ul className={css.mobileLinks}>
          {mobileNav.map((navItem) => [
            <li key={navItem.name}>
              <Link
                className={css.textLink}
                url={navItem.href}
                newWindow={navItem.newWindow}
              >
                {navItem.name}
              </Link>
            </li>,
          ])}
        </ul>
      </Col>

      {getNav(loggedIn).map((navGroup) => (
        <Col className="hidden-xs" key={navGroup.href} xs={2}>
          <div className="h7 text-uppercase mvl mhn text-bold">
            <Link
              className={css.textLink}
              url={navGroup.href}
              newWindow={navGroup.newWindow}
            >
              {navGroup.heading}
            </Link>
          </div>
          <ul className="list-unstyled mbl">
            {navGroup.links.map((navItem) =>
              navItem.render !== false ? (
                <li className="mvm" key={navItem.name}>
                  <Link
                    className={css.textLink}
                    url={navItem.href}
                    newWindow={navItem.newWindow}
                  >
                    {navItem.name}
                  </Link>
                </li>
              ) : null
            )}
          </ul>
        </Col>
      ))}

      <Col sm={4}>
        <SocialLinks className="mtl mbxl" />
        <div className="h7 text-uppercase mvl text-bold">Download our app</div>
        <ul className={classnames(css.app, 'list-inline mbl')}>
          <li>
            <LightButton empty href={BLConstants.FIREBASE_IOS_URL} newWindow>
              <i className="fa fa-apple" aria-hidden="true" /> Apple Store
            </LightButton>
          </li>
          <li>
            <LightButton
              empty
              href={BLConstants.FIREBASE_ANDROID_URL}
              newWindow
            >
              <i className="fa fa-android" aria-hidden="true" /> Google Play
            </LightButton>
          </li>
        </ul>
      </Col>
    </Row>
    <Row>
      <Col xs={12}>
        <p className="ptxl">
          &copy; 2011-{new Date().getFullYear()} Babylist, Inc
        </p>
      </Col>
    </Row>
  </div>
)

Footer.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
}

export default withContextualizedTracking()(Footer)
